import React from 'react';
import Post from '../Post/Post'
import per from '../../../assets/post/2.jpeg';

const News = () => {
  const Posts = [
    {
      id: 1,
      desc: "As we close out the week slightly back in the red for May I wanted to make a quick post to briefly discuss the volatility and remind you all about what you need to do in July due to me adding funds.",
      photo: per,
      date: "5 mins ago",
      userId: 1,
      like: 32,
      comment: 9,
    },
    {
      id: 2,
      photo: per,
      date: "15 mins ago",
      userId: 2,
      like: 2,
      comment: 1,
    },
    {
      id: 3,
      desc: "As we close out the week slightly back in the red for May I wanted to make a quick post to briefly discuss the volatility and remind you all about what you need to do in July due to me adding funds.",

      date: "1 hour ago",
      userId: 3,
      like: 61,
      comment: 2,
    },
    {
      id: 4,
      photo: per,
      date: "4 hours ago",
      userId: 4,
      like: 7,
      comment: 3,
    },
    {
      id: 5,
      desc: "As we close out the week slightly back in the red for May I wanted to make a quick post to briefly discuss the volatility and remind you all about what you need to do in July due to me adding funds.",
      date: "5 hours ago",
      userId: 5,
      like: 23,
      comment: 5,
    },
    {
      id: 6,
      photo: per,
      date: "1 day ago",
      userId: 6,
      like: 44,
      comment: 6,
    },
    {
      id: 7,
      desc: "As we close out the week slightly back in the red for May I wanted to make a quick post to briefly discuss the volatility and remind you all about what you need to do in July due to me adding funds.",
      photo: per,
      date: "2 days ago",
      userId: 7,
      like: 52,
      comment: 3,
    },
    {
      id: 8,
      photo: per,
      date: "3 days ago",
      userId: 8,
      like: 15,
      comment: 1,
    },
    {
      id: 9,
      desc: "As we close out the week slightly back in the red for May I wanted to make a quick post to briefly discuss the volatility and remind you all about what you need to do in July due to me adding funds.",

      date: "5 days ago",
      userId: 9,
      like: 11,
      comment: 2,
    },
    {
      id: 10,
      photo: per,
      date: "1 week ago",
      userId: 10,
      like: 104,
      comment: 12,
    }
  ];
  return (
    <div className='news-post-container'>
      {
        Posts.map((p) => (
          <Post key={p.id} post={p} />
        ))
      }
    </div>
  );
};

export default News;